export const MONTHS = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Aout',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre'
]

export const SEASONS = {
  winter: { label: 'Hiver', months: [11, 0, 1] },
  spring: { label: 'Printemps', months: [2, 3, 4] },
  summer: { label: 'Été', months: [5, 6, 7] },
  automn: { label: 'Automne', months: [8, 9, 10] }
}
